'use client';

export { default } from './DialogContent';
export { default as dialogContentClasses } from './dialogContentClasses';
export * from './dialogContentClasses';